import { cn } from '@/utils/cn';
import { CheckCircle, XCircle, Clock, Loader2 } from 'lucide-react';
import { formatDateTime } from '@/utils/formatters';

interface Step {
  name: string;
  status: string;
  timestamp: string;
}

interface ExecutionTimelineProps {
  steps: Step[];
}

export function ExecutionTimeline({ steps }: ExecutionTimelineProps) {
  const getIcon = (status: string) => {
    switch (status) {
      case 'completed': case 'success': return <CheckCircle className="h-4 w-4 text-success-500" />;
      case 'failed': case 'error': return <XCircle className="h-4 w-4 text-danger-500" />;
      case 'running': return <Loader2 className="h-4 w-4 animate-spin text-primary-400" />;
      default: return <Clock className="h-4 w-4 text-neutral-500" />;
    }
  };

  return (
    <div className="space-y-0">
      {steps.map((step, index) => (
        <div key={index} className="flex gap-3">
          <div className="flex flex-col items-center">
            <div className="flex h-8 w-8 items-center justify-center rounded-full bg-neutral-100 dark:bg-neutral-800 border border-neutral-200 dark:border-neutral-700">
              {getIcon(step.status)}
            </div>
            {index < steps.length - 1 && (
              <div className={cn('w-0.5 flex-1 min-h-[24px]', step.status === 'completed' || step.status === 'success' ? 'bg-success-500/30' : 'bg-neutral-200 dark:bg-neutral-700')} />
            )}
          </div>
          <div className="pb-6">
            <p className="text-sm font-medium text-neutral-900 dark:text-neutral-200">{step.name}</p>
            <p className="text-xs text-neutral-500">{formatDateTime(step.timestamp)}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
